import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import AllDisplays from './pages/AllDisplays';

function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route path='/:playlistId' element={<AllDisplays/>} />
        <Route path='/:playlistId/:code' element={<AllDisplays/>} />
        <Route path='/mac/:mac' element={<AllDisplays/>}/>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
